import { http } from 'utils/http'

import { Changelog } from './types'

export const reportsApi = {
  getBenchmarkOptionsByGroup(getState: () => unknown, group = '') {
    return http.get(getState, `reports/benchmark/${group}`)
  },
  getChangelog(getState: () => unknown, changelog: Changelog) {
    return http.post(getState, `reports/changelog`, changelog)
  },
}
